export const ReviewPromptStateDefault = Object.freeze({
	shownAt: 0,
	snoozedUntil: 0,
	completedAt: 0,
	completionReason: "",
	dismissCount: 0,
	eligibleAt: 0,
	blockUntil: 0,
	meaningfulUsageAtMap: {},
})
